export enum MultiMediaTypeEnum {
    PICTURE = "Picture",
    VIDEO = "Video",
    FILE = "File"
}
